import { chainWalk } from '../../../../../../utils/helpers';

export const getSinglesVolume = (outboundVolume, singlesEnabled) => {
  const singlesPlanningChargeOverride = chainWalk(
    () => outboundVolume.overrides.singles.overrideKeyValueMap.singlesPlanningCharge,
    null
  );
  const singlesPredictedCharge = singlesEnabled ? outboundVolume['singlesPredictedCharge'] : 0;
  const singlesPlanningCharge = singlesEnabled
    ? singlesPlanningChargeOverride == null
      ? singlesPredictedCharge
      : parseFloat(singlesPlanningChargeOverride || 0)
    : 0;
  const singlesRodeoBacklog = singlesEnabled ? outboundVolume['rodeoSinglesBacklog'] : 0;
  return { singlesPredictedCharge, singlesPlanningCharge, singlesRodeoBacklog };
};

export const getVnaVolume = (outboundVolume) => {
  const vnaPredictedCharge = outboundVolume['vnaPredictedCharge'];
  const vnaRodeoBacklog = outboundVolume['rodeoVNABacklog'];
  return { vnaPredictedCharge, vnaRodeoBacklog };
};

export const getPick2RebinVolume = (outboundVolume, singlesEnabled, isUnitsOverrideUiEnabled = false) => {
  const { vnaPredictedCharge } = getVnaVolume(outboundVolume);
  const { singlesPlanningCharge } = getSinglesVolume(outboundVolume, singlesEnabled);
  const atropsOverrideCapacityPercentage = chainWalk(
    () => outboundVolume.overrides.pick2rebin.overrideKeyValueMap.atropsOverrideCapacityPercentage,
    null
  );
  let pickToRebinPredictedCharge = outboundVolume['pickToRebinPredictedCharge'];
  let pickToRebinMaxPotentialCharge = Math.max(
    outboundVolume['atropsCapacity'] - outboundVolume['atropsScheduled'] - vnaPredictedCharge - singlesPlanningCharge,
    0
  );
  let pickToRebinPlanningCharge = Math.min(pickToRebinPredictedCharge, pickToRebinMaxPotentialCharge);
  pickToRebinPlanningCharge =
    atropsOverrideCapacityPercentage == null
      ? pickToRebinPlanningCharge
      : getPick2RebinOverridePlanningCharge(
          outboundVolume,
          atropsOverrideCapacityPercentage,
          singlesEnabled,
          isUnitsOverrideUiEnabled
        );
  let pickToRebinRodeoBacklog = outboundVolume['rodeoPickToRebinBacklog'];

  return {
    pickToRebinPredictedCharge,
    pickToRebinMaxPotentialCharge,
    pickToRebinPlanningCharge,
    pickToRebinRodeoBacklog
  };
};

export const getPick2RebinOverridePlanningCharge = (
  outboundVolume,
  atropsOverrideCapacityPercentage,
  singlesEnabled,
  isUnitsOverrideUiEnabled = false
) => {
  const { vnaPredictedCharge } = getVnaVolume(outboundVolume);
  const { singlesPlanningCharge } = getSinglesVolume(outboundVolume, singlesEnabled);
  const overrideVolumeUnits = isUnitsOverrideUiEnabled
    ? parseFloat(atropsOverrideCapacityPercentage || 0)
    : Math.round((parseFloat(atropsOverrideCapacityPercentage || 0) * outboundVolume['atropsCapacity']) / 100);
  return Math.max(
    overrideVolumeUnits - outboundVolume['atropsScheduled'] - vnaPredictedCharge - singlesPlanningCharge,
    0
  );
};

export const getSortableVolume = (outboundVolume, singlesEnabled, isUnitsOverrideUiEnabled = false) => {
  const { singlesPredictedCharge, singlesPlanningCharge } = getSinglesVolume(outboundVolume, singlesEnabled);
  const { pickToRebinPredictedCharge, pickToRebinMaxPotentialCharge, pickToRebinPlanningCharge } = getPick2RebinVolume(
    outboundVolume,
    singlesEnabled,
    isUnitsOverrideUiEnabled
  );
  let sortablePredictedCharge = pickToRebinPredictedCharge + singlesPredictedCharge;
  let sortableMaxPotentialCharge = pickToRebinMaxPotentialCharge + singlesPlanningCharge;
  let sortablePlanningCharge = pickToRebinPlanningCharge + singlesPlanningCharge;
  return { sortablePredictedCharge, sortableMaxPotentialCharge, sortablePlanningCharge };
};

export const getTotalVolume = (outboundVolume, singlesEnabled, isUnitsOverrideUiEnabled = false) => {
  const { vnaPredictedCharge, vnaRodeoBacklog } = getVnaVolume(outboundVolume);
  const { singlesRodeoBacklog } = getSinglesVolume(outboundVolume, singlesEnabled);
  const { pickToRebinRodeoBacklog } = getPick2RebinVolume(outboundVolume, singlesEnabled, isUnitsOverrideUiEnabled);
  const { sortablePlanningCharge } = getSortableVolume(outboundVolume, singlesEnabled, isUnitsOverrideUiEnabled);
  let totalRodeoBacklog = pickToRebinRodeoBacklog + vnaRodeoBacklog + singlesRodeoBacklog;
  let totalPlanningVolume = totalRodeoBacklog + sortablePlanningCharge + vnaPredictedCharge;
  return { totalRodeoBacklog, totalPlanningVolume };
};

export const getSinglesOverrideGuardrails = (outboundVolume, isUnitsOverrideUiEnabled = false) => {
  const { sortableMaxPotentialCharge } = getSortableVolume(outboundVolume, true, isUnitsOverrideUiEnabled);
  const { pickToRebinPlanningCharge } = getPick2RebinVolume(outboundVolume, true, isUnitsOverrideUiEnabled);
  const minVolume = 0;
  const maxVolume = Math.floor(sortableMaxPotentialCharge - pickToRebinPlanningCharge * 0.75);
  return { minVolume, maxVolume };
};
